import { spacesMessages } from 'src/features/spaces/utils/messages';
import { SPACE_TYPE, DISALLOW_USAGE_FOR } from 'src/features/spaces/utils/types';
import { zoneMessages } from 'src/features/zone/utils/messages';

export const spaceTypeTranslationMap: Record<SPACE_TYPE, { id: string; defaultMessage: string }> = {
    [SPACE_TYPE.REGULAR]: spacesMessages.regular,
    [SPACE_TYPE.DISABLED]: spacesMessages.disabledSpace,
    [SPACE_TYPE.MOTORCYCLE]: spacesMessages.motorcycle,
    [SPACE_TYPE.FAMILY]: spacesMessages.family,
    [SPACE_TYPE.BUS]: spacesMessages.bus,
    [SPACE_TYPE.BIG]: spacesMessages.big,
};

export const disallowedVisitorTranslationMap: Record<DISALLOW_USAGE_FOR, { id: string; defaultMessage: string }> = {
    [DISALLOW_USAGE_FOR.CLIENT]: zoneMessages.client,
    [DISALLOW_USAGE_FOR.VIP]: zoneMessages.vip,
    [DISALLOW_USAGE_FOR.RESIDENT]: zoneMessages.resident,
    [DISALLOW_USAGE_FOR.STAFF]: zoneMessages.staff,
    [DISALLOW_USAGE_FOR.SERVICE]: zoneMessages.service,
    [DISALLOW_USAGE_FOR.SUBSCRIPTION]: spacesMessages.subscription,
    [DISALLOW_USAGE_FOR.RESERVATION]: zoneMessages.reservation,
};
